import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('link', {
    url: {
        title: 'URL',
        type: 'url',
        validation: function validation(Rule) {
            return Rule.uri({
                allowRelative: true,
                scheme: [
                    'http',
                    'https',
                    'mailto',
                    'tel'
                ]
            });
        }
    },
    linkType: {
        title: 'Link Type',
        type: 'string',
        description: 'Defaults to internal',
        options: {
            list: [
                'internal',
                'external'
            ]
        }
    }
}, []);
var validator = z.object({
    _type: z.literal('link'),
    url: z.string().optional(),
    linkType: z.enum([
        'internal',
        'external'
    ]).optional()
});
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=link.js.map